import { Heading, Loading } from '@myxplor/ui'
import React from 'react'
import { calculateDeterminationSubmitValues, submissionToForm } from '../../../../../accs-gov-enrolments/helpers'
import LocalAsyncStore from '../../../../../local-async-store'
import DefaultForm from '../../../../../ui/forms/default-form'
import { hasAvailableAction } from '../../../../../ui/gov-actions'
import ACCSForm from '../../../../accs/form'

const formValue = 'copy_submission'

const available = (record) => hasAvailableAction(record, 'copy_to_determination')

const apiEndPoint = (regHolderId, {gov_id, type}) => 
  `/api/services/${regHolderId}/accs/${type.toLowerCase()}/${gov_id}/submission`

const actionForm = ({regHolderId, child}) => ({async, handleSuccess}) => {
  if (async.loading || !async.data)
    return <Loading>Fetching submission...</Loading>

  if(!async.success)
    return (<Heading small>Fetching submission failed</Heading>)

  return (
    <DefaultForm
      url={
        process.env.REACT_APP_API_HOST +
        `/api/services/${regHolderId}/children/${child.crn}/accs/submit-determination`
      }
      name={formValue}
      label='Copy to Determination'
      loadingTitle='Submitting ACCS Determination...'
      calculateSubmitValues={calculateDeterminationSubmitValues}
      handleSuccess={() =>
        handleSuccess(
          { [formValue]: 'ACCS Determination has been created.' },
          formValue
        )
      }
      formOptions={{ defaultValues: submissionToForm(child, async.data) }}
      formComponent={(props) => <ACCSForm {...props} isDetermination={true} child={child} />}
    />
  )
}

const formWrapper = ({ regHolderId, child, record }) =>
  LocalAsyncStore('async', actionForm({regHolderId, child, record}), () => apiEndPoint(regHolderId, record))

export const copySubmission = ({ regHolderId, child, record, refresh_accs_gov_enrolments }) => {
  return available(record)
    ?
    {
      label: 'Copy to Determination',
      value: 'copy_to_determination',
      actionForm: formWrapper({ regHolderId, child, record }),
      onCompletePreserveAction: true,
      onComplete: refresh_accs_gov_enrolments
    }
    : null
}



// WEBPACK FOOTER //
// ./src/care-enrolments/details/accs-gov-enrolments/actions/copy-submission/index.js